import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { Thread } from '../message-center.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-message-center-thread-filter',
  imports: [MatButton],
  templateUrl: './message-center-thread-filter.component.html',
  styleUrl: './message-center-thread-filter.component.scss'
})
export class MessageCenterThreadFilterComponent implements OnInit, OnChanges {
  @Input() threads: Thread[] = [];
  @Input() state: 'closed' | 'open' = 'open';
  @Output() filteredThreads = new EventEmitter<Thread[]>();

  ngOnInit() {
    this.filterThreads();
  }

  filterThreads() {
    let filtered: Thread[];
    if (this.state === 'open') {
      filtered = this.threads.filter((t) => !t.dateArchived);
    } else {
      filtered = this.threads.filter((t) => !!t.dateArchived);
    }
    this.filteredThreads.emit(filtered);
  }

  getBorderWidth(state: string) {
    return this.state == state ? 4 : 0;
  }

  ngOnChanges(): void {
    this.filterThreads();
  }

  public setState(state: string) {
    if (this.state === state) {
      return;
    }
    this.state = state as 'closed' | 'open';
    this.filterThreads();
  }
}
